import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const MentorshipSection = () => {
    const { school_slug } = useParams();

    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    /* ---------------- SECTION STATE ---------------- */

    const [form, setForm] = useState({
        heading: "",
        quote_1: "",
        paragraph_1: "",
        paragraph_2: "",
        highlight_text_1: "",
        highlight_text_2: "",
        quote_2: "",
    });

    /* IMAGES */

    /* ---------------- IMAGE STATES (CSR STYLE) ---------------- */
    const [mentorImages, setMentorImages] = useState({
        1: { file: null, caption: "" },
        2: { file: null, caption: "" },
        3: { file: null, caption: "" },
        4: { file: null, caption: "" },
    });

    const [preview, setPreview] = useState({
        1: null,
        2: null,
        3: null,
        4: null,
    });

    const handleImageChange = (slot, file) => {
        if (!file) return;

        setMentorImages(prev => ({
            ...prev,
            [slot]: {
                ...prev[slot],
                file: file   // ✅ keep object structure
            }
        }));

        setPreview(prev => ({
            ...prev,
            [slot]: URL.createObjectURL(file),
        }));
    };
    

    /* ---------------- FETCH DATA ---------------- */
    useEffect(() => {
        fetchMentorship();
    }, [school_slug]);

    const fetchMentorship = async () => {
        try {
            const res = await axios.get(
                `${baseAPIUrl}admin/about_page/get_mentorship_section/${school_slug}`,
                { withCredentials: true }
            );

            if (res.data.status === 1 && res.data.data) {
                const { section, images } = res.data.data;

                /* ---------- SECTION ---------- */
                if (section) {
                    setForm({
                        heading: section.heading || "",
                        quote_1: section.quote_1 || "",
                        paragraph_1: section.paragraph_1 || "",
                        paragraph_2: section.paragraph_2 || "",
                        highlight_text_1: section.highlight_text_1 || "",
                        highlight_text_2: section.highlight_text_2 || "",
                        quote_2: section.quote_2 || "",
                    });
                }
                
                /* ---------- IMAGES (SLOTS) ---------- */
                const previewState = { 1: null, 2: null, 3: null, 4: null };
                const imageState = {
                    1:{ file:null, caption:"" },
                    2:{ file:null, caption:"" },
                    3:{ file:null, caption:"" },
                    4:{ file:null, caption:"" },
                };

                if (images && images.length) {
                    images.forEach((img) => {
                    if (img.sort_order >= 1 && img.sort_order <= 4) {
                        previewState[img.sort_order] = `${baseAPIUrl}assets/images/aboutsec/${img.image_name}?t=${Date.now()}`;


                        imageState[img.sort_order].caption = img.caption || "";
                    }
                    });
                }

                setPreview(previewState);
                setMentorImages(imageState);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    /* HANDLERS */

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    /* ---------------- Submit ---------------- */
    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");

        try {
            setLoading(true);
            const formData = new FormData();
            formData.append("school_slug", school_slug);
            formData.append("section", JSON.stringify(form));

            /// SEND IMAGES + CAPTIONS BY SLOT
            for (let i = 1; i <= 4; i++) {
                if (mentorImages[i].file) {
                    formData.append(`mentor_image_${i}`, mentorImages[i].file);
                }
                formData.append(`caption_${i}`, mentorImages[i].caption);
            }

            const res = await axios.post(
                `${baseAPIUrl}admin/about_page/add_edit_mentorship_section`,
                formData,
                { withCredentials: true,
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );
            await fetchMentorship();
            setMessage(res.data.message);
            scrollToTop();
        } catch (err) {
            console.error(err);
            setMessage("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const removeImage = async (slot) => {
        const confirmDelete = window.confirm(
            `Are you sure you want to delete Image ${slot}? This action cannot be undone.`
        );

        if (!confirmDelete) return;

        try {
            setLoading(true);

            const formData = new FormData();
            formData.append("school_slug", school_slug);
            formData.append("slot", slot);

            const res = await axios.post(
                `${baseAPIUrl}admin/about_page/delete_mentorship_image`,
                formData,
                {   withCredentials: true,
                }
            );

            if (res.data.status === 1) {
                // ✅ update UI
                setPreview(prev => ({ ...prev, [slot]: null }));
                setMentorImages(prev => ({
                    ...prev,
                    [slot]: { file: null, caption: "" }
                }));

                scrollToTop();
                setMessage(res.data.msg);
            } else {
                scrollToTop();
                setMessage(res.data.msg || "Failed to delete image");
            }
        } catch (err) {
            console.error(err);
            setMessage("Failed to delete image.");
        } finally {
            setLoading(false);
        }
    };


    if (loading) return <p>Loading...</p>;

    return (
        <div className="content-wrapper">
            {/* Content Header (Page header) */}
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 text-dark">Mentorship section</h1>
                        </div>{/* /.col */}
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/admin/dashboard">Dashboard</a></li>
                                <li class="breadcrumb-item active">Mentorship section</li>
                            </ol>
                        </div>{/* /.col */}
                    </div>{/* /.row */}
                </div>{/* /.container-fluid */}
            </div>
            {/* /.content-header */}
            {/* Main content */}
            <section className="content">
                <div className="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                {/*-- /.card-header --*/}
                                <div class="card-header">
                                    <h4>Edit Mentorship section</h4>
                                </div>
                                <form onSubmit={handleSubmit} encType="multipart/form-data">
                                    <div class="card-body">
                                        {message && (
                                            <p className="text-center text-danger">{message}</p>
                                        )}
                                        {/* Heading */}
                                        <input type="hidden" name="school_slug" value={school_slug}></input>
                                        <div className="form-group">
                                            <label>Heading of section</label>
                                            <input
                                                type="text"
                                                name="heading"
                                                className="form-control"
                                                placeholder="Heading of section"
                                                value={form.heading}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        {/* Quote 1 */}
                                        <div className="form-group">
                                            <label>Quote 1</label>
                                            <input
                                                type="text"
                                                name="quote_1"
                                                rows="5"
                                                className="form-control"
                                                placeholder="Quote 1"
                                                value={form.quote_1}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        {/* Paragraph 1 */}
                                        <div className="form-group">
                                            <label>Paragraph 1</label>
                                            <textarea
                                                name="paragraph_1"
                                                rows="6"
                                                className="form-control"
                                                placeholder={`Paragraph 1`}
                                                value={form.paragraph_1}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        {/* Paragraph 2 */}
                                        <div className="form-group">
                                            <label>Paragraph 2</label>
                                            <textarea
                                                name="paragraph_2"
                                                rows="6"
                                                className="form-control"
                                                placeholder={`Paragraph 2`}
                                                value={form.paragraph_2}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        {/* Highlight text 1 */}
                                        <div className="form-group">
                                            <label>Highlight text 1</label>
                                            <textarea
                                                name="highlight_text_1"
                                                rows="6"
                                                className="form-control"
                                                placeholder={`Highlight text 1`}
                                                value={form.highlight_text_1}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        {/* Highlight text 2 */}
                                        <div className="form-group">
                                            <label>Highlight text 2</label>
                                            <textarea
                                                name="highlight_text_2"
                                                rows="6"
                                                className="form-control"
                                                placeholder={`Highlight text 2`}
                                                value={form.highlight_text_2}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        {/* Quote 2 */}
                                        <div className="form-group">
                                            <label>Quote 2</label>
                                            <textarea
                                                name="quote_2"
                                                rows="5"
                                                className="form-control"
                                                placeholder="Quote 2"
                                                value={form.quote_2}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        {/* Mentorship images */}
                                        <div className="form-group">
                                            <label>Mentorship images (Exactly 4)</label>
                                            {[1, 2, 3, 4].map(slot => (
                                            <div key={slot} className="mb-3 border p-2">
                                                <label>Image {slot}</label>

                                                {preview[slot] ? (
                                                    <>
                                                        <img
                                                            src={preview[slot]}
                                                            className="img-fluid mb-2"
                                                            style={{ maxWidth: "150px", display: "block", marginBottom: "8px" }}
                                                        />

                                                        <button
                                                            type="button"
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() => removeImage(slot)}   // 👈 API call here
                                                            style={{marginBottom: "10px" }}
                                                        >
                                                            Remove Image
                                                        </button>
                                                    </>
                                                ) : null}

                                                <input
                                                    type="file"
                                                    name={`mentor_image_${slot}`}
                                                    accept="image/*"
                                                    onChange={(e) => handleImageChange(slot, e.target.files[0])}
                                                 />

                                                <input
                                                    type="text"
                                                    className="form-control mt-2"
                                                    placeholder="Image caption"
                                                    value={mentorImages[slot].caption}
                                                    onChange={e =>
                                                        setMentorImages(prev => ({
                                                        ...prev,
                                                        [slot]: { ...prev[slot], caption: e.target.value }
                                                        }))
                                                    }
                                                />
                                            </div>
                                            ))}
                                        </div>

                                    </div>

                                    <div className="card-footer">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={loading}
                                        >
                                            {loading ? "Submitting..." : "Submit"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div >
    )
}
export default MentorshipSection;